import React from 'react'
import { SmlsButton, SmlsModal } from '@smiles/smiles-ui-kit-react'
import { ModalBody } from 'reactstrap'
import { useTranslation } from 'react-i18next'
import HyperLink from '../../Hyperlink'
import { usePasswordLockModal } from '../../../context/PasswordLockContext'
import { getLink } from '../../../utils'

export function LastTryPasswordLockModal() {
    const { t } = useTranslation("login_page")

    const { passwordLockModal } = usePasswordLockModal()
    const { hasModalOpen, passwordLockCount, closeModal } = passwordLockModal
    
    function handleHyperlinkClick() {
        window.location.href = getLink('recuperar/senha');
    }
    
    return (
      <SmlsModal
        isOpen={hasModalOpen && passwordLockCount === 4}
        type="right"
        toggle={closeModal}
        onExit={closeModal}
        className="smls-register-error-modal modal-response-status"
      >
        <ModalBody className="smls-modal-body">
          <div className="smls-modal-header">
            <h4>{t('last_try.title')}</h4>
          </div>
          <div className="smls-modal-text">
            <p>{t('last_try.subtitle')}</p>
          </div>

          <div className="btns-modal-response">
            <SmlsButton className="primary-btn-modal" id="btn_gotIt" onClick={closeModal} text={t('last_try.button')} />
            
            <div className="mt-4">
              <HyperLink onClick={handleHyperlinkClick} text={t('last_try.forgot_password_button')} />
            </div>
          
          </div>
        </ModalBody>
      </SmlsModal>
    )
}